/**
 * PMS overlay yield — appended last in PEARL_SHELL_CSS so contract tests that
 * match the first `.pw-mini-tab {` block still see the real mini-tab rule.
 *
 * Host attribute `data-pearl-yield="curve-notes"` is toggled by
 * `notes-shell-yield.ts` while Curve's note editor is open.
 */
export const YIELD_CSS = `
    :host([data-pearl-yield="curve-notes"]) .pw-root,
    :host([data-pearl-yield="curve-notes"]) .pw-root *,
    :host([data-pearl-yield="curve-notes"]) .pw-pnl,
    :host([data-pearl-yield="curve-notes"]) .pw-login-popup,
    :host([data-pearl-yield="curve-notes"]) .pw-login-popup *,
    :host([data-pearl-yield="curve-notes"]) .pw-mini-tab {
      pointer-events: none !important;
    }
    :host([data-pearl-yield="curve-notes"]) .pw-pnl {
      display: none !important;
    }
`;
